import { z } from 'zod';
import { income } from '../shared/model';
import { ApplicantType } from '../types';

export const baseIncomeReviewSchema = z.object({
  applicant: z.object({
    type: z.nativeEnum(ApplicantType),
    income: income,
    isIncomeReviewConfirmation: z.boolean({
      message: 'Please confirm your income details',
    }),
    usingOpenBanking: z.boolean().optional(),
  }),
});

export const incomeReviewSchema = baseIncomeReviewSchema;

export type IncomeReviewFieldsType = z.infer<typeof incomeReviewSchema>;
